import React, { useEffect, useState } from "react";
import {
    Card, CardBody, Row, Col, Input, Button, Table, Badge
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import Pagination from "../../Helpers/Pagination";
import { toast } from "react-toastify";
import { getCookie } from "../../Helpers/Utils";

const SalesList = () => {

    const dispatch = useDispatch();
    const user = useSelector(s => s.customer.customer);
    const loading = useSelector(s => s.loading.loading);

    const [rows, setRows] = useState([]);
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState("");

    const loadSales = async () => {
        dispatch(loadingTrue());

        const res = await Handler({
            method: "get",
            url: `/payments/search.php?outlet_id=${user?.outlet_id}`,
            params: {
                outlet_id: user.outlet_id,
                q: search,
                limit,
                offset: (page - 1) * limit
            }
        });

        dispatch(loadingFalse());

        if (!res?.success) {
            toast.error(res?.msg);
            return;
        }
        setRows(res?.data?.data || []);
        setTotal(res?.data?.pagination?.total || 0);
    };

    const formatIST = (utcDate) =>
        new Date(utcDate + "Z").toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        });


    useEffect(() => { loadSales(); }, [page, search]);

    const openPdf = (url, sale_id, customer_id) => {
        // const token = localStorage.getItem("token"); // or cookie util
        const token = getCookie('token')

        if (!token) {
            toast.error("Login expired");
            return;
        }

        const w = window.open("", "_blank");
        w.document.write("Generating...");

        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`   // 🔥 THIS FIX
            },
            body: JSON.stringify({
                sale_id: sale_id,
                outlet_id: user.outlet_id
            })
        })
            .then(res => {
                if (!res.ok) throw new Error("Unauthorized");
                return res.blob();
            })
            .then(blob => {
                const fileURL = URL.createObjectURL(blob);
                w.location.href = fileURL;
            })
            .catch(() => {
                w.close();
                toast.error("Unauthorized / Session expired");
            });
    };

    return (
        <>
            <Row className="mb-3">
                <Col><h5 className="fw-bold">Received Payments</h5></Col>
            </Row>
            <Card className="shadow-sm">
                <CardBody>

                    <Row className="mb-3">
                        <Col md={4}>
                            <Input
                                placeholder="Search Invoice / Sale ID / Customer"
                                value={search}
                                onChange={e => {
                                    setPage(1);
                                    setSearch(e.target.value);
                                }}
                            />
                        </Col>
                    </Row>

                    <Table hover responsive className="align-middle">
                        <thead className="table-light">
                            <tr>
                                <th>#</th>
                                <th>Sale ID</th>
                                <th>Customer</th>
                                <th>Date</th>
                                <th className="text-end">Billing Amount</th>
                                <th className="text-end">Redeem Points</th>
                                <th className="text-end">Manual Discount</th>
                                <th className="text-end">Paid Amount</th>
                                <th className="text-center">Payment Mode</th>
                                <th className="text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>

                            {rows?.length === 0 && (
                                <tr>
                                    <td colSpan="10" className="text-center text-muted">
                                        No sales found
                                    </td>
                                </tr>
                            )}

                            {rows && rows?.map((r, i) => (
                                <tr key={r.sale_id}>
                                    <td>{(page - 1) * limit + i + 1}</td>
                                    <td>{r.sale_id}</td>
                                    <td>
                                        {r?.customer_id
                                            ? `${r?.customer_id} (${r?.customer_name || "–"})`
                                            : "Walk-in"}
                                    </td>
                                    <td>{formatIST(r.created_at)}
                                        {/* { new Date(r.created_at).toLocaleString()} */}
                                    </td>
                                    <td className="text-end">
                                        ₹ {Number(r?.meta?.original_amount || 0).toFixed(2)}
                                    </td>

                                    <td className="text-end">
                                        ₹ {Number(r?.meta?.redeem_value || 0).toFixed(2)}
                                    </td>

                                    <td className="text-end">
                                        ₹ {Number(r?.meta?.manual_discount || 0).toFixed(2)}
                                    </td>
                                    <td className="text-end">
                                        ₹ {Number(r?.amount || 0).toFixed(2)}
                                    </td>

                                    <td className="text-center">{r?.payment_mode} </td>
                                    <td className="text-center d-flex gap-3">
                                        <Button
                                            disabled={loading}
                                            color="primary"
                                            className="w-100"
                                            onClick={() =>
                                                openPdf("https://software.dizoratbd.com/bill/apis/invoices/receipt.php", r?.sale_id, r?.customer_id)
                                                // openPdf("http://localhost/bill_backend_production/apis/invoices/receipt.php", r?.sale_id, r?.customer_id)
                                            }
                                        >
                                            Receipt
                                        </Button>

                                        <Button
                                            disabled={loading}
                                            color="warning"
                                            className="w-100"
                                            onClick={() =>
                                                // openPdf("http://localhost/bill_backend_production/apis/invoices/generate.php", r?.sale_id, r?.customer_id)
                                                openPdf("https://software.dizoratbd.com/bill/apis/invoices/generate.php", r?.sale_id, r?.customer_id)
                                            }
                                        >
                                            Invoice
                                        </Button>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>

                    <Pagination
                        total={total}
                        limit={limit}
                        page={page}
                        onPageChange={setPage}
                    />

                </CardBody>
            </Card>
        </>
    );
};

export default SalesList;
